import styled from "styled-components";
import { motion } from "framer-motion";

export const OR_Container = styled(motion.div)`
	position: fixed;
	inset: 0;
	z-index: 9000;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const OR_Backdrop = styled(motion.div)`
	position: absolute;
	inset: 0;
	background: rgba(0, 0, 0, 0.6);
	backdrop-filter: blur(6px);
`;

export const OR_Content = styled(motion.div)`
	position: relative;
	z-index: 1;
	color: white;
	font-size: 20px;
`;
